module.exports = __webpack_public_path__ + "static/media/frog(24).6956ee75.PNG";